import { Anchor, ShieldCheck } from "lucide-react";
import { PoweredBy } from "@/components/PoweredBy";

export const BrandMark = ({ dark = false }) => (
  <div className="flex items-center gap-2.5">
    <div className={`w-9 h-9 rounded-md flex items-center justify-center ${dark ? "bg-white/10" : "bg-[#0A192F]"}`}>
      <Anchor className="w-5 h-5 text-sky-400" />
    </div>
    <span className={`font-display font-semibold text-lg tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
      Havnekalkulator
    </span>
  </div>
);

export const AuthShell = ({ children, isSuper = false, logo = null, logoAlt = "" }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-white">
    <aside className="relative hidden lg:flex flex-col justify-between p-12 bg-[#0A192F] overflow-hidden">
      <img src="/img/harbor.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-35" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/70 to-transparent" />
      <div className="relative"><BrandMark dark /></div>
      <div className="relative max-w-md">
        {isSuper && (
          <div className="inline-flex items-center gap-2 mb-5 px-3 py-1 rounded-full bg-amber-400/15 text-amber-300 text-xs font-medium tracking-wide uppercase">
            <ShieldCheck className="w-3.5 h-3.5" /> Begrenset tilgang
          </div>
        )}
        <h1 className="font-display text-4xl text-white font-semibold leading-tight">
          {isSuper ? "Plattformadministrasjon" : "Havneavgifter, beregnet riktig."}
        </h1>
        <p className="mt-4 text-slate-300 leading-relaxed">
          {isSuper
            ? "Administrer kunder, brukere, statistikk og endringslogg for alle havnekalkulatorer."
            : "Oppdater satser, minstepriser og utseende på kalkulatoren din. Endringene vises umiddelbart på nettsiden."}
        </p>
      </div>
      <p className="relative text-xs text-slate-400">Sikker innlogging · Data lagres kryptert</p>
    </aside>
    <main className="flex flex-col items-center p-6 sm:p-12">
      {logo && (
        <div className="w-full max-w-sm fade-up" data-testid="login-customer-logo-wrap">
          <img src={logo} alt={logoAlt ? `${logoAlt} logo` : "Kundens logo"} className="max-h-16 max-w-[220px] w-auto object-contain" data-testid="login-customer-logo" />
        </div>
      )}
      <div className="flex-1 flex items-center w-full max-w-sm">
        <div className="w-full fade-up">
          <div className="lg:hidden mb-10"><BrandMark /></div>
          {children}
        </div>
      </div>
      <footer className="pt-10 w-full"><PoweredBy /></footer>
    </main>
  </div>
);
